/* global RequestInit */
import React, { useState } from 'react';
import { t } from 'i18next';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import { accountRetailerService } from '@/projects/platform/services/account-retailer-service';
import { countryService } from '@/projects/platform/services/country-service';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';

const App = () => {

  const store = createCustomStore({
    key: ["id"],
    load: accountRetailerService.getRegions,
    insert: accountRetailerService.createRegion,
    update: accountRetailerService.updateRegion,
    remove: accountRetailerService.deleteRegion,
    byKey: (key, loadOptions) => {
      if (key) {
        loadOptions.filter = ["Id", "=", key];
      }
    },
  });

  const [countryStore] = useState(() => createCustomStore({
    key: 'id',
    load: countryService.lookupCountries,
    byKey: (key, loadOptions) => {
      if (key) {
        loadOptions.filter = ["Id", "=", key];
      }
    },
  }));

  const handleRowUpdating = async (e: any) => {
    e.newData = { ...e.oldData, ...e.newData }
  };

  return (
    <React.Fragment>
      <DataGridWrapper
        datasource={store}
        permissonCode='Retailer.Region'
        onRowUpdating={handleRowUpdating}
        pagerVisible={true}
        filterVisible={true}
        headerFilterVisible={true}
        props={{ id: "region-list-grid" }}
        enableCustomToolbarContent={false}
        searchPanelVisible={true}
        columnChooser={false}
        columns={[
          {
            dataField: "name",
            caption: "Region Name",
            required: true,
            requiredMessage: t("region_name_is_required"),
          },
          {
            dataField: "regionCode",
            caption: "Region Code",
            required: true,
            requiredMessage: t("region_code_is_required"),
          },
          {
            dataField: "countryId",
            caption: "Country",
            required: true,
            requiredMessage: t("country_is_required"),
            lookup: {
              dataSource: countryStore,
              valueExpr: "id",
              displayExpr: "name"
            }
          }
        ]}
      />
    </React.Fragment>


  );
};

export default App;
